import cn from "classnames"
import React from "react"

import { ProgramsType } from "~/api/types/Programs"
import { Heading } from "~/components/Heading/Heading"

import styles from "./index.module.css"

type ItemsProps = {
  programs: ProgramsType[]
  slug?: string
} & JSX.IntrinsicElements["div"]

export const Items: React.FC<ItemsProps> = ({ className, programs, slug }) => {
  const programUrl = slug !== "career" ? "/sustainable-development/programs/" : "/about/career/"

  if (programs.length === 0) {
    return null
  }

  return (
    <div className={cn(className, styles.Items)}>
      {programs.slice(0, 3).map(({ id, code, name, previewPicture, section }) => (
        <div key={id} className={styles.Item}>
          <a className={styles.Anchor} href={programUrl + code} />

          {previewPicture && (
            <div className={styles.Image}>
              <img src={previewPicture} />
            </div>
          )}

          {section.name && (
            <Heading className={styles.Heading} like="h5">
              {section.name}
            </Heading>
          )}

          {name && (
            <Heading className={styles.Title} like="h2">
              {name}
            </Heading>
          )}
        </div>
      ))}
    </div>
  )
}
